import {
  Avatar,
  Button,
  ButtonBase,
  InputLabel,
  ListItem,
  Stack,
  Typography,
} from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleX } from 'Images';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface IFilterTags {
  filterTags: string[];
  isActive: (tag: string) => boolean;
  toggleFilter: (tag: string) => void;
  resetTags: () => void;
}
export const FilterTags = ({
  filterTags,
  isActive,
  toggleFilter,
  resetTags,
}: IFilterTags) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals);
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);
  const isDesktop = useIsDesktop();

  return (
    <Stack gap={'24px'}>
      <Typography variant={'body1'} component='h2'>
        {dictionary.filterTags.filterTitle}
      </Typography>
      <Stack
        direction={'row'}
        gap={'16px 6px'}
        flexWrap={'wrap'}
        component={'ul'}
        padding={0}
        margin={0}
        role='tablist'
      >
        {filterTags.map((tag, index) => (
          <ListItem sx={{ padding: 0, width: 'fit-content' }} key={index}>
            <Button
              onClick={() => toggleFilter(tag)}
              color='primary'
              role='tab'
              tabIndex={0}
              sx={{
                padding: '0px 15px',
                height: isDesktop ? '38px' : '32px',
                outline: (theme) =>
                  isActive(tag)
                    ? 'none'
                    : `1px solid ${theme.palette.primary.shade_100}`,
                background: (theme) =>
                  isActive(tag) ? theme.palette.primary.main : '#fff',
                color: (theme) =>
                  isActive(tag) ? '#fff' : theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: (theme) =>
                    isActive(tag) ? theme.palette.primary.main : '#fff',
                },
              }}
            >
              <InputLabel id={`label-chip-${tag.trim().replace(' ', '-')}`}>
                <Typography
                  variant='body6'
                  color={isActive(tag) ? '#fff' : 'primary.main'}
                  sx={{
                    cursor: 'pointer',
                  }}
                >
                  {tag}
                </Typography>
              </InputLabel>
            </Button>
          </ListItem>
        ))}
      </Stack>
      <Stack padding={0} margin={0}>
        {filterTags.find((tag) => isActive(tag)) && (
          <ButtonBase
            onClick={resetTags}
            onKeyDown={onEnterOrEscapeKeyDown}
            sx={{
              display: 'flex',
              padding: '0',
              alignItems: 'center',
              alignSelf: 'flex-start',
              '&:hover': {
                background: 'transparent',
              },
            }}
          >
            <Avatar
              sx={{ width: '22px', height: '22px' }}
              src={PurpleX}
              alt={generalDictionary.resetSelection}
            />
            <Typography variant='body2' color={'primary.main'}>
              {generalDictionary.resetSelection}
            </Typography>
          </ButtonBase>
        )}
      </Stack>
    </Stack>
  );
};
